import { EXAM_ELIGIBILITY, InstanceWithAuth } from '../routes';

/** check if POS is eligible for exam or not */
export const checkIfEligible = () => {
  return InstanceWithAuth(EXAM_ELIGIBILITY);
};
